import { useTranslation } from 'react-i18next'
import HelpTooltipIcon from '../../../../components/HelpTooltipIcon'
import { formatAverage, formatThousands } from '../../../../utils/formatNumber'
import BasicWidget from '../../Stats/components/widgets/BasicWidget'
import { useCountersAnalyticsData } from '../../analytics/hooks/use-counters-analytics-data'

const GameMileageWidget = () => {
  const { t } = useTranslation()
  const { headlineStats, isLoading } = useCountersAnalyticsData()
  const totalPlayers = headlineStats.joinedPlayers

  return (
    <BasicWidget
      title={formatThousands(headlineStats.mileage)}
      subtitle={t('stats.milesCovered')}
      iconRight={
        <HelpTooltipIcon
          text={t('stats.tooltips.mileage', { distanceSetting: '0.5' })}
        />
      }
      chipLabel={t('stats.milesPerPlayer', {
        number: formatAverage(
          totalPlayers ? headlineStats.mileage / totalPlayers : 0
        ),
      })}
      isLoading={isLoading}
    />
  )
}

export default GameMileageWidget
